import React from "react";
import { ComponentProps, StaffMember } from "../../../types";
import * as styles from "./BoardMemberDetail.module.css";
import { SectionWrapper } from "../../containers/SectionWrapper";
import { CustomRichTextElement } from "../../elements/CustomRichTextElement/CustomRichTextElement";
import { KontentImageElement } from "../../elements/KontentImageElement/KontentImageElement";

interface Props extends ComponentProps {
  boardMember: StaffMember;
  orientation?: "image_left" | "image_right";
}

export const BoardMemberDetail: React.FC<Props> = ({
  boardMember,
  orientation,
  ...props
}) => {
  let containerClassName = styles.contentContainer;

  if (orientation === "image_left") {
    containerClassName += ` ${styles.reverse}`;
  }

  return (
    <SectionWrapper {...props}>
      <div
        className={styles.boardmemberdetail}
        data-kontent-element-codename="board_member"
      >
        <div className={containerClassName}>
          <div className={styles.textContainer}>
            <div className={styles.name}>
              {boardMember.firstName} {boardMember.lastName}
            </div>
            {(boardMember.title || boardMember.appointedYear) && (
              <div className={styles.title}>
                {boardMember.title}
                {boardMember.title && boardMember.appointedYear && ", "}
                {boardMember.appointedYear}
              </div>
            )}
            {boardMember.biography && (
              <CustomRichTextElement content={boardMember.biography} />
            )}
          </div>
          <div className={styles.imageContainer}>
            {boardMember?.image && (
              <KontentImageElement
                image={boardMember.image.item}
                alt={boardMember.image.alt}
                layout="constrained"
                height={550}
                width={515}
              />
            )}
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
};
